import { DetailStub } from '../components/listing-details/detail-section/detail-section.component';

interface IResidentialExpandedDetailSections {
  propertyDetails: Array<DetailStub>;
  homeFeatures: Array<DetailStub>;
  roomDetails: Array<DetailStub>;
  interiorFeatures: Array<DetailStub>;
  exteriorFeatures: Array<DetailStub>;
  utilities: Array<DetailStub>;
  neighbourhoodFeatures: Array<DetailStub>;
}

// New mappings for listing details section and rows
export class ResidentialExpandedDetailSections
  implements IResidentialExpandedDetailSections {
  propertyDetails: Array<DetailStub> = [];
  homeFeatures: Array<DetailStub> = [];
  roomDetails: Array<DetailStub> = [];
  interiorFeatures: Array<DetailStub> = [];
  exteriorFeatures: Array<DetailStub> = [];
  utilities: Array<DetailStub> = [];
  neighbourhoodFeatures: Array<DetailStub> = [];
  other: Array<DetailStub> = []; // catch all for anything that didn't make it in to the other categories
}

// For detail rows that are added dynamically
// The keys correspond to the variable names inside listing.features that aren't being explicitly added
export const propertyDetailsFeatureGroups: string[] = [
  'Lease',
  'Lease Requirements',
  'Lease Term'
];

export const homeFeaturesFeatureGroups: string[] = [
  'Architecture',
  'Year Built',
  'Year Built Description',
  'Year Built Source',
  'Approx Age',
  'Location',
  'Ownership',
  'Type',
  'Pets Allowed',
  'Levels',
  'SqFT Range'
];

export const roomDetailsFeatureGroups: string[] = [];

export const interiorFeaturesFeatureGroups: string[] = [
  'Inclusions',
  'Appliances',
  'Exclusions',
  'Interior Features',
  'Master Description',
  'Br Description',
  '2nd Br Description',
  '3rd Br Description',
  '4th Br Description',
  '5th Br Description',
  'Laundry',
  'LaundryFeatures',
  'Pantry Description',
  'Foyer Description',
  'Dining Description',
  'Living Description',
  'Kitchen Description',
  'Sitting Description',
  'Den Description',
  'Family Description',
  'Bathroom Description',
  'Office Description',
  'Rec Description',
  'Breakfast Description',
  'Workshop description',
  'Tandem Description',
  'Sunroom Description',
  'Study Description',
  'Solarium Description',
  'Powder Rm Description',
  'Play Description',
  'Nursery Description',
  'Mudroom Description',
  'Media/Ent Description',
  'Library Description',
  'Great Rm Description',
  'Games Description',
  'Furnace Description',
  'Exercise Description',
  'Dinning Description',
  'Den Description',
  'Common Rm Description',
  'Cold/Cant Description',
  'Association Amenities',
  'Cooling',
  'Locker',
  'Locker Description',
  'Heating Fuels',
  'Flooring'
];

export const exteriorFeaturesFeatureGroups: string[] = [
  'AssociationAmenities',
  'Balcony',
  'Acreage Range',
  'Fronting On',
  'Site Description',
  'Exterior Build',
  'Exterior Features',
  'Lot Description',
  'Lot Shape',
  'Lock Box',
  'Security Features',
  'ConstructionMaterials'
];

export const utilitiesFeatureGroups: string[] = [
  'Tenant Pays',
  'Owner Pays',
  'Rent Includes',
  'Assessed Fees',
  'Association Fee Frequency',
  'Telephone Service',
  'TV Service',
  'Utilities',
  'Utilities Included',
  'Utility Description',
  'Waste',
  'Water',
  'Water Heater',
  'Water Heater Location',
  'Water Heating Paid By',
  'Water Paid By',
  'Water Purifier',
  'Water Service',
  'Water Softener',
  'Water Source',
  'Water Treatment',
  'Water Type',
  'CommonInterest'
];

export const neighbourhoodFeaturesFeatureGroups: string[] = [
  'Municipality',
  'BuyerAgentAOR',
  'MLSAreaMinor',
  'Area',
  'Community Features',
  'Community',
  'View'
];
